import {
    Directive,
    Input,
    OnChanges,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import { FeatureFlagConfig } from './feature-flag-config';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[featureFlag]',
    standalone: false
})
export class FeatureFlagDirective implements OnChanges {
    @Input() featureFlag: string;

    constructor(
        private vcr: ViewContainerRef,
        private tpl: TemplateRef<any>,
        private flags: FeatureFlagConfig // TODO: how to resolve at runtime?
    ) {}
    @Input() featureFlagElse?: TemplateRef<any>;

    ngOnChanges() {
        if (!(this.flags && this.featureFlag)) { return; }
        if (
            this.flags.config[this.featureFlag] === true ||
            (this.flags.config['*'] === true &&
                this.flags.config[this.featureFlag] === undefined)
        ) {
            this.vcr.createEmbeddedView(this.tpl);
        } else if (this.featureFlagElse) {
            this.vcr.createEmbeddedView(this.featureFlagElse);
        }
    }
}
